import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { Icon, Button, Text } from '@/ui'
import { mtc, TextColors, TypographyStyles } from '@/styles'
import { useAppDispatch } from '@/utils/typeHelpers'
import { openMessageThread } from '../adviser-chat.slice'
import { useHavenMessagesView } from '../hooks/useHavenMessagesView'
import { TICKET_CREATED_EXPECTATION_TEXT } from '../lib/constants'
import { TicketFiles } from './TicketFiles'

interface TicketCreatedProps {
  ticketId: number
  subject: string
  attachedFiles?: string[]
  droppedAttachments?: string[]
  onSend?: (message: string) => void
}

export const TicketCreated = ({
  ticketId,
  subject,
  attachedFiles,
  droppedAttachments,
  onSend,
}: TicketCreatedProps) => {
  const dispatch = useAppDispatch()
  const messagesViewEnabled = useHavenMessagesView()

  const handleAddComment = (): void => {
    if (messagesViewEnabled) {
      dispatch(openMessageThread(ticketId))
      return
    }
    onSend?.(`I'd like to add a comment to ticket #${ticketId}`)
  }

  return (
    <div
      className={mtc(
        'my-2 rounded-[16px]',
        'bg-green-0 border border-green-50',
        'p-4 flex flex-col'
      )}
    >
      <div className="flex gap-4 items-start">
        <Icon
          icon={faCheck}
          color="text-green-100"
          className="text-[16px] shrink-0 mt-0.5"
        />

        <div className="flex flex-1 flex-col gap-3 items-start min-w-0">
          <div className="flex flex-col gap-0.5 flex-1 min-w-0">
            <Text
              variant={TypographyStyles.LABEL_MD}
              color={TextColors.HIGHLIGHT}
            >
              Ticket #{ticketId} submitted
            </Text>
            <Text
              variant={TypographyStyles.BODY_SM}
              color={TextColors.HIGHLIGHT}
            >
              {subject}
            </Text>
            <Text
              variant={TypographyStyles.BODY_SM}
              color={TextColors.HIGHLIGHT}
            >
              {TICKET_CREATED_EXPECTATION_TEXT}
            </Text>
          </div>
          <TicketFiles
            attachedFiles={attachedFiles}
            droppedAttachments={droppedAttachments}
          />
          {onSend && (
            <Button variant="secondary" size="sm" onClick={handleAddComment}>
              Add Comment
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
